import PropTypes from 'prop-types';
import React from 'react';
import { LINK_HOME } from '../../config/links/links';

const HeaderLogo = ({ isMobile = false }) => {
  return (
    <>
      <div className="d-flex col-4 col-md-auto align-items-center justify-content-center text-center">
        <div className="logo-container">
          <a href={`${LINK_HOME}/`}>
            <img
              alt="Logo"
              className="logo"
              height={isMobile ? '26px' : '59px'}
              src={`https://resources.wowcher.co.uk/images/wowcher-logo.svg`}
              width={isMobile ? '40px' : '92px'}
            />
          </a>
        </div>
      </div>
      <style jsx>{`
        .logo-container {
          display: flex;
          min-height: 41px;
          align-items: center;
          justify-content: center;
          max-height: ${isMobile ? '26px' : '92px'};
          max-width: ${isMobile ? '80px' : '92px'};
        }
        .logo {
          display: flex;
          height: ${isMobile ? '26px' : 'auto'};
          width: ${isMobile ? 'auto' : '92px'};
          align-self: flex-start;
        }
        .top {
          position: absolute;
          top: 50px;
        }
      `}</style>
    </>
  );
};

HeaderLogo.propTypes = {
  isMobile: PropTypes.bool,
};

export default HeaderLogo;
